<template>
    <Head title="Employee Management"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-3">
                                    <AutoComplete
                                        forceSelection
                                        placeholder="Nama Karyawan"
                                        id="dd"
                                        :dropdown="true"
                                        v-model="selectedEmployee"
                                        :suggestions="autoFilteredValue"
                                        @complete="searchEmployee($event)"
                                        field="name"
                                    />
                                </div>
                                <div class="field col-12 md:col-3">
                                    <Calendar v-model="startDate" :showIcon="true" dateFormat="dd-mm-yy" placeholder="Dari Tanggal">
                                    </Calendar>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <Calendar v-model="endDate" :showIcon="true" dateFormat="dd-mm-yy" :showButtonBar="true" placeholder="Sampai Tanggal">
                                    </Calendar>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <Button
                                            label="Cari"
                                            icon="pi pi-search"
                                            class="p-button-primary ml-2"
                                            @click="changeFilters"
                                        />
                                </div>
                            </div>
                    </template>
                </Toolbar>
                <Toolbar class="mb-4">
                    <template #start>
                        <Button
                            label="New Payroll"
                            icon="pi pi-plus"
                            class="p-button-primary ml-2"
                            @click="addModel"
                        />
                    </template>
                    <template #end>
                        <Button
                                label="Print Receipt"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportSlipToPdf"
                                :disabled="
                                    !selectedModels || !selectedModels.length || selectedModels.length > 1
                                "
                            />
                        <!-- <Button
                                label="Print Summary In PDF"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportSummaryToPdf"
                            /> -->
                        <Button
                                label="Print Summary In Excel"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportSummaryToExcel"
                            />
                        <Button
                                label="Print Laporan BPJS"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportBPJSToPdf"
                            />
                        <Button
                                label="Export To Coretax"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportToCoretaxFormat"
                            />
                    </template>
                </Toolbar>
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    :selectAll="selectAll"
                    @select-all-change="onSelectAllChange"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Payrolls</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="payroll_no"
                        header="No Payroll"
                        :sortable="true"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.payroll_no }}
                        </template>
                    </Column>
                    <Column
                        field="payroll_date"
                        header="Date"
                        :sortable="true"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Payroll Date</span>
                            {{ slotProps.data.payroll_date }}
                        </template>
                    </Column>
                    <Column
                        field="nik"
                        header="NIK"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">NIK</span>
                            {{ slotProps.data.nik }}
                        </template>
                    </Column>
                    <Column
                        field="name"
                        header="Name"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.name }}
                        </template>
                    </Column>
                    <Column
                        field="employee.placement.name"
                        header="Placement"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Placement</span>
                            {{ slotProps.data.placement }}
                        </template>
                    </Column>
                    <Column
                        field="position"
                        header="Position"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Position</span>
                            {{ slotProps.data.position }}
                        </template>
                    </Column>
                    <Column headerStyle="width:20%;min-width:10rem;">
                        <template #body="slotProps">
                            <Button
                                icon="pi pi-pencil"
                                class="mr-2"
                                @click="editModel(slotProps.data.id)"
                            />
                            <Button
                                icon="pi pi-trash"
                                class="p-button-warning mt-2"
                                @click="confirmRejectSelected(slotProps.data)"
                            />
                        </template>
                    </Column>
                </DataTable>
                <Dialog
                    v-model:visible="deleteModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete
                            <b>{{ model.name }}</b
                            >?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteModel"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import DatatableService from "../../Services/DatatableService";
import Calendar from "primevue/calendar";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AutoComplete,
        Head,
        Button,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
        Calendar,
    },
    props: {'date': new Date()},
    data() {
        return {
            searchFilter: "",
            filters: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            lazyParams: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            models: null,
            selectionTestDialog: false,
            deleteModelDialog: false,
            deleteModelsDialog: false,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            isExporting: false,
            startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
            selectedEmployee: null,
            autoFilteredValue: [],
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
    },
    methods: {
        searchEmployee(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    axios
                        .get(`${this.$page.props.appUrl}api/employees`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                } else {
                    let filterValue = event.query.toLowerCase();
                    axios
                        .get(
                            `${this.$page.props.appUrl}api/employees?search=${filterValue}`
                        )
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
            }, 250);
        },
        loadLazyData() {
            this.loading = true;
            this.datatableService
                .getData(`${this.$page.props.appUrl}api/payrolls/datatable`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        onSelectAllChange(event) {
            const selectAll = event.checked;
            if (selectAll) {
                this.datatableService.getData(this.route("applicants.index"),this.lazyParams).then((data) => {
                    this.selectAll = true;
                    this.selectedModels = data.data;
                });
            } else {
                this.selectAll = false;
                this.selectedModels = [];
            }
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams.first = event.first;
            this.lazyParams.page = event.page;
            this.lazyParams.pageCount = event.pageCount;
            this.lazyParams.rows = event.rows;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField;
            this.lazyParams.sortOrder = event.sortOrder;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onFilter(event) {
            this.lazyParams.filters['search'] = { field: 'name', value: this.searchText };
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        confirmRejectSelected(model){
            this.model = model;
            this.deleteModelDialog = true;
        },
        hideDialog() {
            this.selectionTestDialog = false;
        },
        addModel(){
            this.$inertia.get(`${this.$page.props.appUrl}payrolls/create`);
        },
        editModel(id){
            this.$inertia.get(`${this.$page.props.appUrl}payrolls/${id}`);
        },
        deleteModel() {
            axios
                .delete(`${this.$page.props.appUrl}api/payrolls/${this.model.id}`)
                .then((response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Payroll Deleted",
                        life: 3000,
                    });
                    this.deleteModelDialog = false;
                    this.model = {};
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Payroll not deleted" + error,
                        life: 3000,
                    });
                });
        },
        exportSummaryToPdf(){
            this.isExporting = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + 'api/payrolls/summary',
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Payroll-Summary.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportSummaryToExcel(){
            this.isExporting = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + 'api/payrolls/summary-in-excel',
                responseType: 'blob',
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Payroll-Summary.xlsx');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportSlipToPdf(){
            this.isExporting = true;
            const rawObject = {...this.selectedModels[0]};
            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/payrolls/${rawObject.id}/slip-export`,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Payroll Receipt.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportBPJSToPdf(){
            this.isExporting = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + 'api/payrolls/bpjs-company',
                responseType: 'blob',
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','BPJS-Company.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'id' },
                date: {fromDate: this.startDate, toDate: this.endDate},
            };
        },
        exportToCoretaxFormat() {
            const url = `https://docs.google.com/spreadsheets/d/1GemQQnoJX79RAjw6IDm-5TomDli-wZ3R/edit?gid=1155998306#gid=1155998306`;
            window.open(url, '_blank');
        },
        changeFilters(){
            this.lazyParams.filters = {
                global: {value: this.selectedEmployee ? this.selectedEmployee.id : null, field: 'employee_id'},
                date: {fromDate: this.startDate, toDate: this.endDate},
            };

            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));
            this.loadLazyData();
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
